import React from 'react';

function HeaderError({ errorHeader, errorBody, goBack }) {
  return (
    <div className="name">
      <div className="prev_button">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */}
        <a onClick={goBack} onKeyUp={goBack} />
      </div>
      <div className="error_wrap">
        <div className="error_header">
          {errorHeader}
        </div>
        <div className="error_body">
          {errorBody}
        </div>
      </div>
    </div>
  );
}

export default HeaderError;
